import React, { FC, useState } from 'react';
import Checkbox from 'components/Elements/Checkbox';
import { ChevronDownIcon, ChevronUpIcon } from 'components/Elements/CustomSVGIcon';
import { CheckboxData } from '../types';
import './checkboxparent.scss';
import CheckboxChild from '../CheckboxChild';

interface CheckboxParentProps {
    data: CheckboxData;
    onClick: (tier: 'child' | 'parent', value: string) => void;
    // Forces the children open (used while searching so matching children are
    // visible without manually expanding the parent).
    // eslint-disable-next-line react/require-default-props
    forceOpen?: boolean;
}

const CheckboxParent: FC<CheckboxParentProps> = ({ data, onClick, forceOpen = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { name, description, children, checked, value } = data;
    const hasChildren = children && children.length > 0;
    const showChildren = forceOpen || isOpen;

    const handleCheckboxClick = () => {
        onClick('parent', value);
        if (hasChildren) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className="checkbox-parent-container">
            <div className="search-checkbox-header">
                <Checkbox checked={checked} onClick={handleCheckboxClick} icon="block" />
                <h3 className="search-checkbox-title">{name}</h3>
                {hasChildren && (
                    <div className="search-checkbox-icon-wrapper" onClick={() => setIsOpen(!isOpen)}>
                        {showChildren ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </div>
                )}
            </div>
            <p className="search-checkbox-description">{description}</p>
            {showChildren && hasChildren && (
                <div className="search-checkbox-children-wrapper">
                    {children?.map((child) => <CheckboxChild key={child.value} data={child} onClick={onClick} />)}
                </div>
            )}
        </div>
    );
};

export default CheckboxParent;
